function BurgerMenu({ open, onToggle }) {
  return (
    <button
      type="button"
      className="relative z-[110] flex h-6 w-8 flex-col justify-between border-0 bg-transparent p-0 md:hidden"
      onClick={onToggle}
      aria-label={open ? 'Закрыть меню' : 'Открыть меню'}
      aria-expanded={open}
    >
      <span
        className={`h-0.5 w-full origin-center rounded-full bg-black transition-all duration-300 ${
          open ? 'translate-y-[11px] rotate-45' : ''
        }`}
      />
      <span
        className={`h-0.5 w-full rounded-full bg-black transition-opacity duration-200 ${
          open ? 'opacity-0' : ''
        }`}
      />
      <span
        className={`h-0.5 w-full origin-center rounded-full bg-black transition-all duration-300 ${
          open ? '-translate-y-[11px] -rotate-45' : ''
        }`}
      />
    </button>
  );
}

export default BurgerMenu;
